import { h } from 'preact'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../modal'
import ButtonControl from '../button-control'

type Props = {
  isOpen: boolean,
  onClose: () => void,
  onCancelInvitation: () => void
}

const CancelInviteModal = ({ isOpen, onClose, onCancelInvitation } : Props) =>
  <Modal isOpen={isOpen} size='medium'>
    <ModalHeader title='Cancel invitation? ' onClose={onClose} />
    <ModalBody>
        This will invalidate the link in the original invite email, and this person will not be able to register as a team member.
    </ModalBody>
    <ModalFooter>
      <ButtonControl title='Cancel invitation' variant='danger' onClick={onCancelInvitation} class='qa-cancel-invitation' />
      <ButtonControl title='Cancel' onClick={() => onClose()} />
    </ModalFooter>
  </Modal>

export default CancelInviteModal
